import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Select from '../../Select';

/**
 * Componente utilizado para selicionar um escape que está ligado ao bloco
 */
export default ({ onSelect, label, destinationId }) => {
  const [destinations, setDestinations] = useState([]);
  const [selectedValue, setSectedValue] = useState(null);

  const { currentItem: item, allItems: items } = useSelector(
    (state) => state.items
  );
  const { list: connectors } = useSelector((state) => state.connectors);

  useEffect(() => {
    const connectorsFromItem = connectors.filter(
      (connector) => connector.from === item._id
    );

    const _destinations = [];

    connectorsFromItem.forEach((connector) => {
      const destination = items?.find((_item) => _item._id === connector.to);

      if (destination) {
        _destinations.push(destination);
      }
    });

    setDestinations(_destinations);

    return () => setDestinations([]);
  }, [connectors, items, item]);

  useEffect(() => {
    if (destinationId && destinations) {
      const destinationItem = destinations.find(
        (_item) => _item._id === destinationId
      );

      if (destinationItem) {
        setSectedValue({
          value: destinationItem._id,
          label: destinationItem.title,
        });
      } else {
        setSectedValue(null);
      }
    } else {
      setSectedValue(null);
    }
  }, [destinationId, destinations]);

  const formattedDestinationsOptions = useMemo(() => {
    return destinations
      ? destinations.map((_item) => ({
          value: _item._id,
          label: _item.title,
        }))
      : [];
  }, [destinations]);

  const handleSelect = (option) => {
    setSectedValue(option);

    if (option) {
      onSelect(option.value);
    } else {
      onSelect('');
    }
  };

  return (
    <Select
      label={label}
      options={formattedDestinationsOptions}
      value={selectedValue}
      onChange={(value) => handleSelect(value)}
      getOptionLabel={(option) => `${option.label}: ${option.value}`}
      isClearable
    />
  );
};
